import { httpClient } from '../httpClient';

export const breachesApi = {
  getAll: (params) =>
    httpClient.get('/breach/incidents', { params }),

  getById: (id) =>
    httpClient.get(`/breach/incidents/${id}`),

  // Registered DataSources for the form's "Linked Data Source" picker.
  getDataSources: () =>
    httpClient.get('/breach/data-sources'),

  create: (data) =>
    httpClient.post('/breach/incidents', data),

  update: (id, data) =>
    httpClient.put(`/breach/incidents/${id}`, data),

  delete: (id) =>
    httpClient.delete(`/breach/incidents/${id}`),

  addNote: (id, data) =>
    httpClient.post(`/breach/incidents/${id}/notes`, data),

  notifyAuthority: (id) =>
    httpClient.post(`/breach/incidents/${id}/notify-authority`),

  notifyAffected: (id) =>
    httpClient.post(`/breach/incidents/${id}/notify-affected`),

  // ── Multi-channel data-subject notification (032 Tranche 2, US7) ────────
  // POST /api/breach-notifications/send — body: { breachId, type,
  // notificationType, channel, subject?, message?, content? }. The backend
  // auto-fills templated content and forces the public-media channel for
  // breaches exceeding 10,000 affected subjects (FR-032-052).
  sendNotification: (data) =>
    httpClient.post('/breach-notifications/send', data),

  calculateSeverity: (data) =>
    httpClient.post('/breach/calculate-severity', data),

  getStats: () =>
    httpClient.get('/breach/stats'),

  // ── Command Center (032 Tranche 2, US10) ───────────────────────────────
  // Returns the six widget datasets: activeIncidents, countdowns,
  // sdaiaTracker, timeline30d, notificationGrid, responseMetrics.
  getCommandCenter: () =>
    httpClient.get('/breach/command-center'),

  export: (data) =>
    httpClient.post('/breach/export', data, { responseType: 'blob' }),

  // ── 72h clock (032 Tranche 1) ──────────────────────────────────────────
  // Returns snake_case: { deadline_at, remaining_seconds, zone,
  // escalation_level, thresholds_fired }. remaining_seconds is negative
  // when overdue.
  getClock: (id) =>
    httpClient.get(`/breach/incidents/${id}/clock`),

  // ── 3-stage workflow (032 Tranche 1) ───────────────────────────────────
  // Returns { stage, checklist, stage_history }.
  getWorkflow: (id) =>
    httpClient.get(`/breach/incidents/${id}/workflow`),

  // Updates checklist items for the current stage.
  // Body key is `items` — the PUT /checklist route schema (UPDATE_CHECKLIST_SCHEMA)
  // validates `items`, not `checklist`. Sending the wrong key 400s the request.
  updateChecklist: (id, checklist) =>
    httpClient.put(`/breach/incidents/${id}/checklist`, { items: checklist }),

  // Advances to the next workflow stage; 422 with unmet items if the
  // current stage checklist is incomplete.
  advanceStage: (id) =>
    httpClient.post(`/breach/incidents/${id}/advance-stage`),

  // Records a "notification not required" justification and proceeds to
  // closure.
  notificationNotRequired: (id, justification) =>
    httpClient.post(`/breach/incidents/${id}/notification-not-required`, {
      justification,
    }),

  // ── Post-incident review (032 Tranche 2, US9) ──────────────────────────
  // GET returns the review (or null); { riskRegisterId, riskName } link the
  // breach to the Risk Register entry the completion cascade created.
  getReview: (id) =>
    httpClient.get(`/breach/incidents/${id}/review`),

  // POST records (or updates) the review; allowed only on a closed breach.
  createReview: (id, data) =>
    httpClient.post(`/breach/incidents/${id}/review`, data),

  // ── Tabletop Simulator (032 Tranche 3a, US11) ──────────────────────────
  // Self-contained training tool — never touches live breach data.
  getSimulatorScenarios: () =>
    httpClient.get('/breach/simulator/scenarios'),

  getSimulatorScenario: (scenarioId) =>
    httpClient.get(`/breach/simulator/scenarios/${scenarioId}`),

  getSimulatorMetrics: () =>
    httpClient.get('/breach/simulator/metrics'),

  startSimulatorRun: (scenarioId) =>
    httpClient.post('/breach/simulator/runs', { scenarioId }),

  getSimulatorRun: (runId) =>
    httpClient.get(`/breach/simulator/runs/${runId}`),

  submitSimulatorResponse: (runId, data) =>
    httpClient.post(`/breach/simulator/runs/${runId}/responses`, data),

  completeSimulatorRun: (runId) =>
    httpClient.post(`/breach/simulator/runs/${runId}/complete`),

  abandonSimulatorRun: (runId) =>
    httpClient.post(`/breach/simulator/runs/${runId}/abandon`),
};
